import { ChangeEvent, useState } from "react";
import { ISearchCarrierValue } from "../../interfaces/configuration";
import { useDebounce } from "../../customHooks/useDebounce";
import { Button, FormControl, OutlinedInput } from "@mui/material";

const SearchRoles = ({ handleGetRoles }: any) => {
  const [searchValue, setSearchValue] = useState({} as ISearchCarrierValue);

  const { setSubmitting } = useDebounce(() => {
    if (searchValue.content) {
      setSearchValue({ ...searchValue, activeSearch: true });
      handleGetRoles(searchValue.content);
    }
  });

  const { setSubmitting: setSubmittingClose } = useDebounce(() => {
    setSearchValue({ content: "", activeSearch: false });
    handleGetRoles(searchValue.content);
  });

  return (
    <FormControl size="small" fullWidth>
      <OutlinedInput
        placeholder="Buscar por rol"
        className="f-s-14"
        value={searchValue.content}
        onKeyUp={(e) => e.key === "Enter" && setSubmitting(true)}
        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
          setSearchValue({ ...searchValue, content: value });
        }}
        endAdornment={
          <Button
            className="search-input-adornment"
            onClick={() =>
              searchValue.activeSearch
                ? setSubmittingClose(true)
                : setSubmitting(true)
            }
          >
            <span className="material-symbols-rounded text-muted f-s-24">
              {searchValue.activeSearch ? "close" : "search"}
            </span>
          </Button>
        }
      />
    </FormControl>
  );
};

export default SearchRoles;
